var site = site || {};
site.inits = [];
site.inits.push("site.page.init()");

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.checkLogo = {
	logo: null,
	init: function () {
		site.checkLogo.logo = document.querySelector('#header .logo img');
		site.checkLogo.checkSize();
		window.onresize = function () {
			site.checkLogo.checkSize();
		};
	},
	checkSize: function () {
		if (window.matchMedia('(max-width: 991px)').matches) {
			site.checkLogo.logo.src = '/static/themes/2016/images/sala_mobile.svg';
		}
		else {
			site.checkLogo.logo.src = '/static/themes/2016/images/sala.svg';
		}
	},
};

// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.page = {
	init: function() {
		$('body.page.special .boxText p img').each(function() {
			$(this).unwrap();
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.checkLogo.init();
	site.nav.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});
});
